import { desEncryptMessage, encryptSecretKey } from '@airtel/air-utils';
import { API_CONFIGS } from '../constants/AppConstants';
import { getFromSessionStorage } from '../utils/CommonUtils';
import { generateInteractionId, generateUniqueId } from './commonUtils';

export const createUUID = () => {
   let dt = new Date().getTime();
   const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
   });

   return uuid;
};

export const encryptMessage = (payload: any, publickey: string) => {
   //generate random number
   const secretKey = createUUID();
   const stringifyPayload = JSON.stringify(payload);
   const currentTime = Date.now().toString();

   //DES encryption of payload
   const encryptedPayload = desEncryptMessage(stringifyPayload, secretKey);

   //DES encryption of timestamp
   const encryptedTimestamp = desEncryptMessage(currentTime, secretKey);

   //encrypt random key
   const encryptedKey = encryptSecretKey(secretKey, publickey);

   return `data=${encodeURIComponent(
      encryptedPayload
   )}&key=${encryptedKey}&timestamp=${encodeURIComponent(encryptedTimestamp)}`;
};

// bouncer send otp
export const callSendOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const msisdn = storeValues?.appData?.msisdn;
   // let isOtpModalOpened = data?.[0]?.type == 'resend' ? true : false;
   // const publicKey = localStorage.getItem('key');

   // if (publicKey) {
   // const payload: any = {
   //    msisdn: msisdn,
   //    otpDigitCount: 6,
   //    groupId: 'SKYC_REVERIFICATION',
   //    os: 'ANDROID_LITE',
   // };

   //encrypt the request using DES Algo
   // payloadReq = encryptMessage(payload, publicKey);
   // const payloadReq = JSON.stringify(payload);
   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v1';
   let apiUrlValidateOtp = 'guardian/api/skyc/validateOtp/v1';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'SKYC_REVERIFICATION',
               otpDigitCount: 6,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'close',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify mobile number',
                  subTitle: '6-digit OTP sent to',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 6,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           payload: {
                              eventData: {
                                 inputsDataProps: {
                                    mobileNumber: {
                                       showLoader: false,
                                    },
                                 },
                              },
                              eventName: 'step1Widget',
                           },
                           type: 'nativeEventEmitter',
                        },
                        {
                           type: 'closeModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'change',
                              eventValue: 'change',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'SKYC_LANDING_PAGE',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'verify',
                                 eventValue: 'verify',
                                 customLabel: 'mobile verification',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop8: 'reverification',
                                 prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                                 prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                                 prop5: '{{storeValues:outstationContext.isOutstation}}',
                              },
                           },
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'SKYC_LANDING_PAGE',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'resend',
                                 eventValue: 'resend',
                                 customLabel: 'mobile verification',
                                 eVar21: '{{storeValues:appData.msisdn}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop8: 'reverification',
                                 prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                                 prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                                 prop5: '{{storeValues:outstationContext.isOutstation}}',
                              },
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventValue: 'filled',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        payload: {
                           eventData: {
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                              submitButtonProps: {
                                 leftCta: {
                                    disabled: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [
                     {
                        payload: {
                           eventData: {
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                              submitButtonProps: {
                                 leftCta: {
                                    disabled: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                  ],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        payload: {
                           eventData: {
                              state: 'none',
                              isExpanded: true,
                              inputsDataProps: {
                                 mobileNumber: {
                                    showLoader: false,
                                 },
                              },
                           },
                           shouldResolveData: true,
                           eventName: 'step1Widget',
                        },
                        type: 'nativeEventEmitter',
                     },
                     {
                        type: 'apiCall',
                        payload: {
                           requestType: 'POST',
                           apiUrl: 'guardian/api/skyc/reverification/status/v1',
                           authTokenGroup: 'SKYC_REVERIFICATION',
                           header: [],
                           body: {
                              channel: 'SHOP',
                              interactionId:
                                 '{{storeValues:skycInteractionId.interactionId}}',
                              operation: 'CUST_REVERIFICATION',
                              msisdn: '{{storeValues:appData.msisdn}}',
                              coordinates: '{{storeValues:userLocation}}',
                              otpGenerationDateTime:
                                 '{{storeValues:msisdnOtp.otpGenerationDateTime}}',
                              otpValidationDateTime:
                                 '{{storeValues:msisdnOtp.otpValidationDateTime}}',
                              otp: '{{storeValues:msisdnOtp.otp}}',
                           },
                        },
                     },
                  ],
               },
               apiUrls: {
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`,
                  verifyOtp: `${API_CONFIGS.baseUrl}${apiUrlValidateOtp}`,
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'SKYC_LANDING_PAGE',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               customLabel: 'mobile verification',
               eVar21: '{{storeValues:appData.msisdn}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop8: 'reverification',
               prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
               prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
               prop5: '{{storeValues:outstationContext.isOutstation}}',
            },
         },
      ],
   });
};

//skyc-new bouncer send otp
export const callSendOtpSkycNew = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   let apiUrlSentOtp = 'guardian/api/skyc/sendOtp/v2';

   return onUserAction({
      actions: [
         {
            type: 'otpConsent',
            payload: {
               msisdn,
               groupId: 'SKYC_NEW',
               otpDigitCount: 6,
               sessionStorageKey: 'SKYC_REVERIFICATION',
               modalProps: {
                  showCross: true,
                  onClosePress: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'close',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
               },
               otpWidgetProps: {
                  rtnOnChangeCta: true,
                  title: 'Verify alternate number via OTP',
                  subTitle: '6-digit OTP sent to verify and send updates on',
                  infoTextTop: 'Enter OTP',
                  resendTimerCount: 30,
                  numberOfInputs: 6,
                  startCounter: true,
                  loadingTitle: 'verifying your number',
                  state: 'none',
                  isValidating: false,
                  onChangeCtaPress: {
                     id: 'onMsisdnChange',
                     actions: [
                        {
                           type: 'closeModal',
                        },
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'new_acq_postpaid_skyc_landing_page',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventLabel: 'phone number',
                              customValue: '',
                              customLabel: 'button',
                              eVar21: '{{storeValues:appData.loggedInNumber}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop45: '{{storeValues:appData.subJourney}}',
                              eVar36: '{{storeValues:appData.msisdn}}',
                              prop4: 'SKYC',
                              prop9: '{{storeValues:appData.lob}}'
                           },
                        },
                     ],
                  },
                  id: 'artistOtpModal',
                  primaryCtaProps: {
                     buttonType: 'primary',
                     style: {
                        marginTop: 0,
                     },
                     title: 'Verify',
                     size: 'md',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'verify',
                                 customValue: '',
                                 customLabel: 'button',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 prop4: 'SKYC',
                                 prop9: '{{storeValues:appData.lob}}'
                              },
                           },
                        ],
                     },
                  },
                  secondaryCtaProps: {
                     buttonType: 'tertiary',
                     counterSuffix: 's',
                     style: {
                        alignSelf: 'center',
                     },
                     title: 'resend',
                     version: 'fixed-padding',
                     onPress: {
                        actions: [
                           {
                              analyticsAction: 'click',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'OtpModalSection',
                                 subSection: 'AirOtpWidget',
                                 eventAction: 'click',
                                 eventLabel: 'resend',
                                 customValue: '',
                                 customLabel: 'button',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 prop4: 'SKYC',
                                 prop9: '{{storeValues:appData.lob}}'
                              },
                           },
                        ],
                     },
                  },
                  onInputFilled: {
                     actions: [
                        {
                           analyticsAction: 'click',
                           analyticsData: {
                              eventCategory: 'SKYC_LANDING_PAGE',
                              section: 'OtpModalSection',
                              subSection: 'AirOtpWidget',
                              eventAction: 'click',
                              eventValue: 'filled',
                              customLabel: 'mobile verification',
                              eVar21: '{{storeValues:appData.msisdn}}',
                              extraData11: '{{storeValues:layoutContext.layout}}',
                              prop8: 'reverification',
                              prop7: '{{storeValues:siNumberStatusDetails.customerZone}}',
                              prop6: '{{storeValues:siNumberStatusDetails.actionRequired}}',
                              prop5: '{{storeValues:outstationContext.isOutstation}}',
                           },
                        },
                     ],
                  },
               },
               toastProps: {},
               onSendOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerSendOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        analyticsAction: 'click',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           eventValue: `6-digit otp sent to verify and send updates on ${msisdn}`,
                           eventLabel: 'verify alternate number via otp',
                           customValue: 'mobile verification',
                           customLabel: 'card',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: '{{storeValues:appData.subJourney}}',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}'
                        },
                     },
                  ],
               },
               onSendOtpFailure: {
                  actions: [],
               },
               onVerifyOtpSuccess: {
                  actions: [
                     {
                        payload: { args: [], utilName: 'storeBouncerValidateOTP' },
                        type: 'callUtilFunction',
                     },
                     {
                        "payload": {
                           "eventData": {
                              "isEmailDisabled": false,
                              "isEmailautofocus": true,
                           },
                           "shouldResolveData": true,
                           "eventName": "UserDetailsWidget"
                        },
                        "type": "nativeEventEmitter"
                     }
                  ],
               },
               onVerifyOtpFailure: {
                  actions: [
                     {
                        analyticsAction: 'impression',
                        analyticsData: {
                           eventCategory: 'new_acq_postpaid_skyc_landing_page',
                           section: 'OtpModalSection',
                           subSection: 'AirOtpWidget',
                           eventAction: 'impression',
                           customValue: 'mobile verification',
                           customLabel: 'OTP is incorrect',
                           eVar21: '{{storeValues:appData.loggedInNumber}}',
                           extraData11: '{{storeValues:layoutContext.layout}}',
                           prop45: '{{storeValues:appData.subJourney}}',
                           eVar36: '{{storeValues:appData.msisdn}}',
                           prop4: 'SKYC',
                           prop9: '{{storeValues:appData.lob}}',
                           eVar10: 'error'
                        }
                     }
                  ],
               },
               apiUrls: {
                  sendOtp: `${API_CONFIGS.baseUrl}${apiUrlSentOtp}`
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'OtpModalSection',
               subSection: 'AirOtpWidget',
               eventAction: 'pageloaded',
               customValue: 'mobile verification',
               customLabel: '',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               prop4: 'SKYC',
               prop9: '{{storeValues:appData.lob}}'
            },
         },
      ],
   });
};

// bouncer verify otp
export const validateOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const msisdn = storeValues?.appData?.msisdn;
   const otp = storeValues?.msisdnOtp?.otp;

   //key
   const publicKey = localStorage.getItem('key');
   if (publicKey) {
      const payload: any = {
         msisdn: msisdn,
         otpDigitCount: 6,
         dynamicTokenRequired: true,
         otp: otp,
         groupId: 'SKYC_REVERIFICATION',
         os: 'ANDROID_LITE',
      };
      // encrypt the request using DES Algo
      // const payloadReq = encryptMessage(payload, publicKey);
      const payloadReq = JSON.stringify(payload);

      const apiUrlValidateLogin = 'guardian/api/skyc/validateOtp/v1';

      return onUserAction({
         actions: [
            {
               type: 'apiCall',
               payload: {
                  requestType: 'POST',
                  apiUrl: apiUrlValidateLogin,
                  body: {
                     key: payloadReq,
                  }
               },
            },
         ],
      });
   }
};

// aadhaar sent otp
export const callSendAadhaarOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const aadhaarNumber = storeValues?.appData?.aadhaarNumber;
   const msisdn = storeValues?.appData?.msisdn;
   const isOtpModalOpened = args?.[0]?.type === 'resend' ? true : false;
   const type = aadhaarNumber?.length === 12 ? 'A' : 'V';
   const apiUrlSentOtp = 'guardian/api/skyc/aadhaar/sendOtp/v1';
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   const lob = storeValues?.appData?.lob;
   return onUserAction({
      actions: [
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlSentOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  msisdn,
                  interactionId: generateInteractionId(),
                  circleId,
                  isResend: isOtpModalOpened,
                  kycDetails: {
                     requestId: generateUniqueId(),
                     requestedFor: 'CUST',
                  },
                  contentPlaceholders: {},
                  documentProofs: [
                     {
                        id: aadhaarNumber,
                        type,
                     },
                  ],
                  lob
               },
               queryParams: {
                  isOtpModalOpened,
               },
            },
         },
         {
            payload: {
               data: {
                  isResendAadharOtp: isOtpModalOpened,
               },
               context: 'resendOtpContext',
            },
            type: 'storeValuesInRedux',
         }
      ],
   });
};

// aadhaar verify otp
export const callVerifyAadhaarOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const aadhaarNumber = storeValues?.appData?.aadhaarNumber;
   const msisdn = storeValues?.appData?.msisdn;
   const otpReferenceId = storeValues?.aadhaarOtpContext?.otpReferenceId;
   const mobileNumber = storeValues?.aadhaarOtpContext?.mobileNumber;
   const email = storeValues?.aadhaarOtpContext?.email;
   const otp = storeValues?.msisdnOtp?.aadhaarNumber;
   const incomeTNCText = args?.[0]?.incomeTNCText;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   const isResendAadharOtp = storeValues?.resendOtpContext?.isResendAadharOtp
   const { journey } = storeValues?.journeyContext || {};
   const type = aadhaarNumber?.length === 12 ? 'A' : 'V';

   let apiUrlValidateOtp = 'guardian/api/skyc/aadhaar/validateOtp/v1';

   return onUserAction({
      actions: [
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlValidateOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  msisdn,
                  incomeTNCText,
                  otpReferenceId,
                  circleId,
                  isResend: isResendAadharOtp,
                  aadhaarNumber,
                  interactionId: generateInteractionId(),
                  contentPlaceholders: {},
                  otp,
                  journey,
                  kycDetails: {
                     requestId: generateUniqueId(),
                     requestedFor: 'cust',
                     mobileNumber,
                     email,
                     residentConsent: true,
                  },
                  documentProofs: [
                     {
                        id: aadhaarNumber,
                        type,
                     },
                  ],
               }
            },
         },
      ],
   });
};

// submit & local referre sent otp
export const callSendRefereeAndSubmitOtp = ({ args, onUserAction, getState }: any) => {
   const { storeValues } = getState();
   const isReferee = args?.[0]?.isReferee;
   const localMsisdn = storeValues?.appData?.localMsisdn;
   const msisdn = storeValues?.appData?.msisdn;
   const customerName = storeValues?.kycDetails?.aadhaarName;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   const { journey } = storeValues?.journeyContext || {};
   const { planName } = storeValues?.planInfo || {};
   const isOtpModalOpened = args?.[0]?.type === 'resend' ? true : false;
   const apiUrlSentOtp = 'guardian/api/skyc/referee-and-submit/sendOtp/v1';
   const selectedNumber = storeValues?.numberContext?.selectedNumber;

   if (localMsisdn === msisdn) {
      let actions: any = [
         {
            payload: {
               eventData: {
                  removeHintTextOnChange: true,
                  inputsDataProps: {
                     mobileNumber: {
                        hintText:
                           'This number & re-verification number cannot be same.',
                        state: 'error',
                     },
                  },
               },
               eventName: 'LOCAL_REFERENCE_DETAILS',
            },
            type: 'nativeEventEmitter',
         },
      ]

      if (journey === 'SKYC_NEW') {
         actions?.push(
            {
               analyticsAction: 'impression',
               analyticsData: {
                  eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
                  section: 'stepsSection',
                  subSection: 'LOCAL_REFERENCE_DETAILS',
                  eventAction: 'impression',
                  eventLabel: 'share a local reference',
                  eventValue: localMsisdn,
                  customValue: 'This number and re-verification number cannot be same',
                  customLabel: 'card',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop7: '{{storeValues:outstationContext.isOutstation}}',
                  prop9: '{{storeValues:appData.lob}}',
                  eVar10: 'error'
               },
            }
         )
      }
      return onUserAction({
         actions
      });
   }

   return onUserAction({
      actions: [
         {
            payload: {
               data: {
                  isRefereeOtp: isReferee,
               },
               context: 'isReferee',
            },
            type: 'storeValuesInRedux',
         },
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlSentOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  msisdn: isReferee ? localMsisdn : msisdn,
                  customerName,
                  isReferee,
                  circleId,
                  isResend: isOtpModalOpened,
                  interactionId: generateInteractionId(),
                  coordinates: {
                     latitude: storeValues?.userLocation?.latitude?.toString(),
                     longitude: storeValues?.userLocation?.longitude?.toString(),
                  },
                  ...(journey === 'SKYC_NEW' && {
                     contentPlaceholders: {
                        selectedNumber,
                        planName,
                        customer_name: customerName
                     }
                  })
               },
               queryParams: {
                  isOtpModalOpened,
               },
            },
         },
         {
            payload: {
               data: {
                  isResendRefereeOtp: isReferee && isOtpModalOpened,
                  isResendSubmitOtp: !isReferee && isOtpModalOpened,
               },
               context: 'resendOtpContext',
            },
            type: 'storeValuesInRedux',
         },
      ],
   });
};

// submit & local referre verify otp
export const callVerifyRefereeAndSubmitOtp = ({ data, onUserAction, getState }: any) => {
   const { storeValues } = getState();

   const localMsisdn = storeValues?.appData?.localMsisdn;
   const msisdn = storeValues?.appData?.msisdn;
   const otp = storeValues?.refreeAndSubmitOtp?.otp;
   const isReferee = storeValues?.isReferee?.isRefereeOtp;
   const circleId = storeValues?.pincodeContext?.pincodeDetails?.circleId
   let apiUrlValidateOtp = 'guardian/api/skyc/referee-and-submit/validateOtp/v1';
   const isResendRefereeOtp = storeValues?.resendOtpContext?.isResendRefereeOtp
   const isResendSubmitOtp = storeValues?.resendOtpContext?.isResendSubmitOtp
   const { journey } = storeValues?.journeyContext || {};
   const { planName } = storeValues?.planInfo || {};
   const selectedNumber = storeValues?.numberContext?.selectedNumber;
   const customerName = storeValues?.kycDetails?.aadhaarName;

   return onUserAction({
      actions: [
         {
            type: 'apiCall',
            payload: {
               requestType: 'POST',
               apiUrl: apiUrlValidateOtp,
               authTokenGroup: 'SKYC_REVERIFICATION',
               body: {
                  ...(journey === 'SKYC_NEW' && { journey }),
                  msisdn: isReferee ? localMsisdn : msisdn,
                  interactionId: generateInteractionId(),
                  otp,
                  isReferee,
                  circleId,
                  isResend: isReferee ? isResendRefereeOtp : isResendSubmitOtp,
                  coordinates: {
                     latitude: storeValues?.userLocation?.latitude?.toString(),
                     longitude: storeValues?.userLocation?.longitude?.toString(),
                  },
                  ...(journey === 'SKYC_NEW' && {
                     contentPlaceholders: {
                        selectedNumber,
                        planName,
                        customer_name: customerName
                     }
                  })
               }
            },
         },
      ],
   });
};

// function to convert timestamp to date
export const convertTimestampToDate = (timestamp: number, journey: string = "") => {
   const date = new Date(timestamp);

   const pad = (num: number, size: number = 2): string => {
      let s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
   };

   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1); // Months are zero-based
   const day = pad(date.getDate());
   const hours = pad(date.getHours());
   const minutes = pad(date.getMinutes());
   const seconds = pad(date.getSeconds());
   const milliseconds = pad(date.getMilliseconds(), 3);

   return `${year}-${month}-${day}${journey === "SKYC_NEW" ? "T" : " "}${hours}:${minutes}:${seconds}${journey === "IMAGE_MODAL" ? "" : "." + milliseconds}`;
};

export const storeBouncerSendOTP = ({ additionalData, onUserAction, getState }: any) => {
   const { timestamp } = additionalData?.dataFromWidget || {};
   const { storeValues = {} } = getState();
   const { journeyContext = {} } = storeValues;
   const { journey } = journeyContext;

   return onUserAction({
      actions: [
         {
            type: 'setDataInSessionStorage',
            payload: {
               key: 'msisdnOtp',
               value: {
                  otpGenerationDateTime: convertTimestampToDate(timestamp, journey),
               },
               clearOnLogout: false,
            },
         },
      ],
   });
};

export const storeBouncerValidateOTP = ({ additionalData, onUserAction, getState }: any) => {
   const { otp, timestamp } = additionalData?.dataFromWidget || {};
   const msisdnOtp = getFromSessionStorage("msisdnOtp")
   const { storeValues = {} } = getState();
   const { journeyContext = {} } = storeValues;
   const { journey } = journeyContext;

   return onUserAction({
      actions: [
         {
            type: 'setDataInSessionStorage',
            payload: {
               key: 'msisdnOtp',
               value: {
                  otp,
                  otpValidationDateTime: convertTimestampToDate(timestamp, journey),
                  ...msisdnOtp
               },
               clearOnLogout: false,
            },
         },
      ],
   });
};
